document.addEventListener('DOMContentLoaded', () => {
  const moneyFormat = window?.Shopify?.money_format || '£{{amount}}';

  function formatMoney(cents) {
    const amount = (Number(cents || 0) / 100).toFixed(2);
    if (moneyFormat.includes('{{amount}}')) {
      return moneyFormat.replace('{{amount}}', amount);
    }
    return `£${amount}`;
  }

  function updateUpsellTotals() {
    document.querySelectorAll('.custom-upsells').forEach((box) => {
      let total = 0;

      box.querySelectorAll('.custom-upsell-checkbox:checked').forEach((input) => {
        total += Number(input.dataset.price || 0);
      });

      const totalEl = box.querySelector('[data-upsell-total]');
      if (totalEl) totalEl.textContent = formatMoney(total);
    });
  }

  document.addEventListener('change', (event) => {
    if (event.target.matches('.custom-upsell-checkbox')) {
      updateUpsellTotals();
    }
  });

  updateUpsellTotals();

  document.addEventListener(
    'click',
    async (event) => {
      const submitButton = event.target.closest(
        'form[data-type="add-to-cart-form"] [type="submit"], form[data-type="add-to-cart-form"] button[name="add"]'
      );

      if (!submitButton) return;

      const form = submitButton.closest('form[data-type="add-to-cart-form"]');
      if (!form) return;

      const upsellBox = form.querySelector('.custom-upsells');
      if (!upsellBox) return;

      const checkedUpsells = [...upsellBox.querySelectorAll('.custom-upsell-checkbox:checked')];

      // Let normal theme behavior run if no upsells are selected
      if (!checkedUpsells.length) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (form.dataset.customUpsellProcessing === 'true') return;
      form.dataset.customUpsellProcessing = 'true';

      try {
        submitButton.disabled = true;

        const variantInput = form.querySelector('input[name="id"]');
        const quantityInput = form.querySelector('input[name="quantity"]');

        const mainVariantId = variantInput ? Number(variantInput.value) : null;
        const mainQty = quantityInput ? Number(quantityInput.value || 1) : 1;

        if (!mainVariantId) {
          throw new Error('Main product variant not found.');
        }

        const items = [
          {
            id: mainVariantId,
            quantity: mainQty
          }
        ];

        checkedUpsells.forEach((input) => {
          const variantId = Number(input.dataset.variantId);
          if (variantId) {
            items.push({
              id: variantId,
              quantity: 1
            });
          }
        });

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ items })
        });

        if (!response.ok) {
          const text = await response.text();
          throw new Error(text || 'Failed to add bundle to cart.');
        }

        const cartResponse = await fetch('/cart.js', {
          headers: {
            Accept: 'application/json'
          }
        });

        const cart = await cartResponse.json();

        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: 'custom-upsells',
              data: {
                source: 'custom-upsells',
                itemCount: cart.item_count
              }
            }
          })
        );

        const cartDrawer = document.querySelector('cart-drawer-component');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else {
          window.location.href = '/cart';
        }
      } catch (error) {
        console.error('Custom upsell add-to-cart error:', error);
        alert('There was a problem adding the selected items to cart.');
      } finally {
        submitButton.disabled = false;
        form.dataset.customUpsellProcessing = 'false';
      }
    },
    true
  );
});